module.exports = __webpack_public_path__ + "img/man_holding_wallet.566846a6.svg";